import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setInsuranceOptionalServicePrice } from '../../../../../../actions/registerShipmentActions';
import { getInsuranceFormCustomPrice } from '../../../../../../helpers/apiHelpers/registerShipmentHelpers';
import FormikFieldWrapper from '../../../../../base/forms/formikFieldWrapper';
import { StyledFormikField } from '../../../../../base/forms/input';

interface Props {
	value: string;
}

const InsuranceForm: FC<Props> = ({ value }) => {
	const dispatch = useDispatch<any>();
	const { t } = useTranslation('registerShipment');
	const { insuranceOptionalServiceCustomPrice } = useSelector(
		({ registerShipmentReducer }) => registerShipmentReducer
	);

	useEffect(() => {
		const price = getInsuranceFormCustomPrice(value);
		if (price !== insuranceOptionalServiceCustomPrice) dispatch(setInsuranceOptionalServicePrice(price));
	}, [value, dispatch, insuranceOptionalServiceCustomPrice]);

	return (
		<>
			<FormikFieldWrapper
				name="insuranceAmount"
				languageComponent="registerShipment"
				label={t('step-optional-services.amount')}
				smallLabel>
				<StyledFormikField
					type="number"
					id="insuranceAmount"
					name="insuranceAmount"
					placeholder={t('step-optional-services.value') + '*'}
				/>
			</FormikFieldWrapper>
		</>
	);
};

export default InsuranceForm;
